import type { SVGProps } from 'react'
import { createSvgIcon } from '@mui/material/utils'

/**
 * Icône de l'Assistant Nabu : le logo Nabu (grille de 27 ramenée à 24), dont le point
 * haut-droit devient une étincelle. En currentColor, comme les icônes MUI.
 */
const glyph = (
  <>
    <path
      opacity={0.5}
      d="M2 5.33a3.33 3.33 0 0 1 6.67 0v13.34a3.33 3.33 0 0 1-6.67 0z"
    />
    <path
      opacity={0.5}
      d="M3.03 7.74a3.33 3.33 0 0 1 4.71-4.71L20.98 16.26a3.33 3.33 0 0 1-4.72 4.72z"
    />
    <circle cx="5.33" cy="5.33" r="3.33" />
    <circle cx="18.67" cy="18.67" r="3.33" />
    <circle cx="5.33" cy="18.67" r="3.33" />
    <path
      transform="translate(13.2 -0.3) scale(0.46)"
      d="M12 2C12.6 7.4 16.6 11.4 22 12 16.6 12.6 12.6 16.6 12 22 11.4 16.6 7.4 12.6 2 12 7.4 11.4 11.4 7.4 12 2Z"
    />
  </>
)

const NabuAssistantIcon = createSvgIcon(glyph, 'NabuAssistant')

/**
 * Même dessin en SVG brut, pour les emplacements qui attendent une icône untitled-ui
 * (enveloppée par l'appelant dans un SvgIcon), comme la navigation des paramètres.
 */
export const NabuAssistantGlyph = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    {glyph}
  </svg>
)

export default NabuAssistantIcon
